import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { inferTypeForFilterStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersStateSelection } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { FilterStoreScope } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { FilterStoreValue } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';

// eslint-disable-next-line complexity
export const createFilterStoreSelection = ({
  value,
  initialValue,
  scope,
  key,
}: {
  value: FilterStoreValue;
  initialValue: FilterStoreValue;
  scope: FilterStoreScope;
  key: string;
}): FiltersStateSelection => {
  const inference = inferTypeForFilterStore(value);
  const initialValueInference = inferTypeForFilterStore(initialValue);

  if (inference.type === 'string') {
    if (initialValueInference.type !== 'string') {
      throw new Error('Initial value must be a string');
    }

    return {
      type: inference.type,
      scope,
      key,
      value: inference.string,
      initialValue: initialValueInference.string,
    };
  }

  if (inference.type === 'string[]') {
    if (initialValueInference.type !== 'string[]') {
      throw new Error('Initial value must be a string array');
    }

    return {
      type: inference.type,
      scope,
      key,
      value: inference.stringArray,
      initialValue: initialValueInference.stringArray,
    };
  }

  if (inference.type === '[number, number]') {
    if (initialValueInference.type !== '[number, number]') {
      throw new Error('Initial value must be a number range');
    }

    return {
      type: inference.type,
      scope,
      key,
      value: inference.numberRange,
      initialValue: initialValueInference.numberRange,
    };
  }

  if (inference.type === 'date') {
    if (initialValueInference.type !== 'date') {
      throw new Error('Initial value must be a date');
    }

    return {
      type: inference.type,
      scope,
      key,
      value: inference.date,
      initialValue: initialValueInference.date,
    };
  }

  if (inference.type === 'dateRange') {
    if (initialValueInference.type !== 'dateRange') {
      throw new Error('Initial value must be a date range');
    }
    return {
      type: inference.type,
      scope,
      key,
      value: inference.dateRange,
      initialValue: initialValueInference.dateRange,
    };
  }

  throw guardExhaustive(inference);
};
